export default __webpack_public_path__ + "static/apartment-416039_1280-d3d3f674053d4165bffc613b50abd9fe.png";